<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    fill="none"
    aria-hidden="true"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
    stroke-width="1.5"
  >
    <path
      d="m1.658 18.662 6.683-9.13 3.482 4.565L16.86 6.99l7.389 11.671H1.658Z"
    />
    <path
      d="m13.141 12.215 2.306-.988 1.224 1.93 1.223-1.93 2.353 1.082M5.047 14.05l2.4-1.223 1.647 1.176 1.553-1.459"
    />
  </svg>
</template>
